export class SubCompanyAgencyApprovalsApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // Durable per-SubCompany agency-approval scalar group (Accounts, DEV-3609/3618).
  // GET returns a CompanyAgencyApprovalModel (or null when never set); PUT upserts
  // the full set of six agencies.
  async getSubCompanyAgencyApprovals({ subCompanyId, config = {} }) {
    return this.#http.get(`/api/sub-companies/${subCompanyId}/agency-approvals`, config);
  }

  async upsertSubCompanyAgencyApprovals({ subCompanyId, approval }) {
    return this.#http.put(`/api/sub-companies/${subCompanyId}/agency-approvals`, approval);
  }
}
